import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoPokerstarsMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 91,
	height: 16,
	viewBox: "0 0 114 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.9563 8.49828C30.9563 10.2706 29.8145 11.4981 27.6232 11.4981H25.1409V14.3877H23.044V5.71454H27.9928C29.8898 5.71454 30.9563 6.76203 30.9563 8.49828ZM28.774 8.52283C28.774 7.69125 28.2408 7.35633 27.4596 7.35633H25.1409V9.76183H27.2857C28.261 9.76183 28.774 9.37781 28.774 8.52283Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.4734 10.072C41.4734 13.011 39.327 14.5123 36.6735 14.5123C34.0204 14.5123 31.8754 13.011 31.8754 10.072C31.8754 7.08381 34.0204 5.57965 36.6735 5.57965C39.327 5.57965 41.4734 7.08381 41.4734 10.072ZM39.2415 10.072C39.2415 8.22431 38.1128 7.31864 36.6735 7.33164C35.2348 7.34478 34.1072 8.23745 34.1072 10.072C34.1072 11.8573 35.236 12.7762 36.6735 12.7762C38.1113 12.7762 39.2415 11.8704 39.2415 10.072Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M46.3133 10.817L44.8987 12.4287V14.3878H42.799V5.71454H44.8944V9.81252L48.5536 5.71454H51.1622L47.735 9.37781L51.5418 14.3878H48.9492L46.3133 10.817Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M54.7496 7.45334V9.12994H59.0391V10.7865H54.7496V12.614H59.5319V14.3876H52.6527V5.71436H59.5319V7.45334H54.7496Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.6652 11.2748H63.1783V14.3879H61.0814V5.71429H66.1172C68.1374 5.71429 69.0682 6.87357 69.0682 8.39405C69.0682 9.79379 68.2869 10.8576 66.9597 11.1343L69.5388 14.3951H66.9975L64.6652 11.2748ZM63.1783 9.60113H65.4595C66.3144 9.60113 66.8853 9.27936 66.8853 8.49832C66.8853 7.6663 66.3057 7.35609 65.5217 7.35609H63.1783V9.60113Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M74.1661 5.58384C75.2162 5.57296 76.2644 5.67698 77.2919 5.89406V7.70396C76.2205 7.44813 75.1228 7.31929 74.0213 7.32009C72.9908 7.32009 72.3723 7.64186 72.3591 8.16337C72.346 8.68531 72.6938 8.91855 73.4749 8.9691L75.1371 9.06788C76.8603 9.16782 77.8775 9.96056 77.8775 11.6096C77.8775 13.8168 76.0055 14.508 73.8722 14.508C72.7865 14.4991 71.7036 14.3953 70.6359 14.1979V12.3414C71.7202 12.5737 72.8255 12.6941 73.9343 12.7008C75.2603 12.7008 75.8559 12.3792 75.8559 11.7211C75.8559 11.1764 75.285 10.94 74.4921 10.9038L73.1158 10.8284C71.4039 10.7416 70.3505 9.98525 70.3505 8.46044C70.3463 6.45182 72.033 5.58384 74.1661 5.58384Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.4048 7.51856H83.5279V14.3879H81.4322V7.51856H78.5342V5.71429H86.4075L86.4048 7.51856Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M92.8914 12.5891H88.7492L88.0552 14.3876H85.7858L89.3435 5.71436H92.2956L95.8545 14.3947H93.5855L92.8914 12.5891ZM92.2332 10.8907L90.8199 7.24465L89.406 10.8907H92.2332Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M100.518 11.2748H99.03V14.3879H96.9343V5.71429H101.969C103.99 5.71429 104.919 6.87357 104.919 8.39405C104.919 9.79379 104.138 10.8576 102.812 11.1343L105.392 14.3951H102.848L100.518 11.2748ZM99.03 9.60113H101.311C102.167 9.60113 102.737 9.27936 102.737 8.49832C102.737 7.6663 102.157 7.35609 101.373 7.35609H99.03V9.60113Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M110.017 5.58387C111.07 5.57232 112.182 5.67645 113.212 5.89409V7.70399C112.139 7.44793 110.978 7.31896 109.875 7.32012C108.847 7.32012 108.227 7.64189 108.214 8.1634C108.201 8.68534 108.548 8.91858 109.331 8.96913L110.991 9.06791C112.714 9.16785 113.791 9.96059 113.791 11.6096C113.791 13.8168 111.857 14.508 109.724 14.508C108.636 14.5008 107.552 14.3982 106.483 14.2023V12.3414C107.567 12.5734 108.673 12.6939 109.781 12.7009C111.109 12.7009 111.703 12.3792 111.703 11.7211C111.703 11.1765 111.133 10.9401 110.339 10.9038L108.962 10.8284C107.253 10.7416 106.193 9.98528 106.193 8.46798C106.193 6.45185 107.884 5.58387 110.017 5.58387Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.4749 4.54102C9.97336 2.04396 8.37967 0.495178 8.37967 0.495178C8.37967 0.495178 6.78279 2.04396 4.28573 4.54102C2.96614 5.85902 0 9.12932 0 12.381C0 14.5485 1.75776 16.3059 3.92554 16.3059C5.34853 16.3059 6.59071 15.5476 7.27873 14.4143V14.4155C7.34806 14.3308 7.46114 14.2615 7.58823 14.2615C7.79028 14.2615 7.97398 14.4039 7.95275 14.5804C7.80154 15.7498 7.14312 18.6309 4.54829 19.6041H12.209C9.61462 18.6309 8.95649 15.7498 8.80629 14.5804C8.78376 14.4039 8.96905 14.2615 9.17081 14.2615C9.29516 14.2615 9.40968 14.3308 9.47901 14.4155L9.48059 14.4143C10.1657 15.5476 11.4092 16.3059 12.8321 16.3059C14.9987 16.3059 16.7577 14.5485 16.7577 12.381C16.7577 9.12932 13.7916 5.85902 12.4749 4.54102Z",
			fill: "#D70A0A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.37949 4.54785L9.44244 7.82349H12.8876L10.1004 9.84858L11.1661 13.1239L8.37949 11.099L5.59301 13.1239L6.65711 9.84858L3.8689 7.82349H7.31669L8.37949 4.54785Z",
			fill: "white"
		})
	]
});
export default SvgLogoPokerstarsMobile;
